import URLS from '@/store/urls';
import apiCall from '@/store/apiCall';
import notificationWithIcon from '@/utils/notification';

const actions = {
  async getZipCodes({ commit }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.zipCodes,
        isToken: true,
      });
      commit('GET_ZIP_CODES_SUCCESS', data);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async addZipCodes({ dispatch }, values) {
    try {
      await apiCall({
        type: 'POST',
        url: URLS.zipCodes,
        body: values,
        isToken: true,
      });
      notificationWithIcon('success', 'Zip Code added');
      dispatch('getZipCodes');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async updateZipCode({ dispatch }, payload) {
    const { name, localPickUp } = payload;
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.zipCodes}/${name}`,
        body: { localPickUp },
        isToken: true,
      });
      notificationWithIcon('success', 'Zip Code updated');
      dispatch('getZipCodes');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteZipCode({ dispatch }, id) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.zipCodes}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Zip Code deleted');
      dispatch('getZipCodes');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
